
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/we-chat",
      function () {
        return require("private-next-pages/android/local/we-chat/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/we-chat"])
      });
    }
  